/**
 * Safely extracts a human-readable error message from any caught value.
 * Handles Axios errors (with or without a response body), plain Error objects,
 * strings, and completely unknown shapes without ever throwing.
 */
export function extractErrorMessage(
  error: unknown,
  fallback = 'An unexpected error occurred',
): string {
  if (typeof error === 'string') return error;

  if (error && typeof error === 'object') {
    const e = error as Record<string, any>;

    // Axios error with a response body
    if (e.response?.data?.message) return String(e.response.data.message);
    if (e.response?.data?.error) return String(e.response.data.error);
    if (e.response?.data && typeof e.response.data === 'string')
      return e.response.data;

    // Plain Error or axios network error (no response)
    if (typeof e.message === 'string' && e.message) return e.message;
  }

  return fallback;
}
